var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", { attrs: { name: "signup-form", width: 0 } }, [
    _c("div", { staticClass: "modal modal__signup show" }, [
      _c(
        "section",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.hide,
              expression: "hide"
            }
          ]
        },
        [
          _c("a", { staticClass: "modal__close" }, [
            _c("i", { staticClass: "icon-close", on: { click: _vm.hide } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal__head" }, [
            _c("img", {
              staticClass: "sphir__logo",
              attrs: {
                src: require("@assets/imgs/sphir-colored-logo.svg"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("h2", [_vm._v(_vm._s(_vm.$t("SIGN_UP.TITLE")))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal__body" }, [
            _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.submit($event)
                  }
                }
              },
              [
                _c(
                  "section",
                  [
                    _c(
                      "div",
                      { staticClass: "input__double" },
                      [
                        _c(
                          "InputField",
                          {
                            attrs: {
                              validation: [
                                "required",
                                "textInput",
                                "minFirstName",
                                "maxString"
                              ],
                              meta: _vm.meta
                            }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.first_name,
                                  expression: "form.first_name"
                                }
                              ],
                              attrs: {
                                id: "first_name",
                                type: "text",
                                name: "first_name",
                                placeholder: " ",
                                required: "required"
                              },
                              domProps: { value: _vm.form.first_name },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "first_name",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "label",
                                attrs: { for: "first_name" }
                              },
                              [_vm._v(_vm._s(_vm.$t("INPUT.FIRST_NAME")))]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "InputField",
                          {
                            attrs: {
                              validation: [
                                "required",
                                "textInput",
                                "minLastName",
                                "maxString"
                              ],
                              meta: _vm.meta
                            }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.last_name,
                                  expression: "form.last_name"
                                }
                              ],
                              attrs: {
                                id: "last_name",
                                type: "text",
                                name: "last_name",
                                placeholder: " ",
                                required: "required"
                              },
                              domProps: { value: _vm.form.last_name },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "last_name",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "label",
                                attrs: { for: "last_name" }
                              },
                              [_vm._v(_vm._s(_vm.$t("INPUT.LAST_NAME")))]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "InputField",
                      {
                        attrs: {
                          validation: ["required", "isEmail"],
                          meta: _vm.meta
                        }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.uid,
                              expression: "form.uid"
                            }
                          ],
                          attrs: {
                            id: "email",
                            type: "email",
                            name: "uid",
                            placeholder: " ",
                            required: "required"
                          },
                          domProps: { value: _vm.form.uid },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.form, "uid", $event.target.value)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { staticClass: "label", attrs: { for: "email" } },
                          [_vm._v(_vm._s(_vm.$t("INPUT.EMAIL")))]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "input__double" },
                      [
                        _c(
                          "InputField",
                          {
                            attrs: {
                              validation: [
                                "required",
                                "passwordSpace",
                                "isPasswordValid"
                              ],
                              "validation-func": _vm.checkEqualField,
                              meta: _vm.meta
                            }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.password,
                                  expression: "form.password"
                                }
                              ],
                              attrs: {
                                id: "password",
                                maxlength: "100",
                                type: "password",
                                autocomplete: "off",
                                name: "password",
                                placeholder: " ",
                                required: "required"
                              },
                              domProps: { value: _vm.form.password },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "password",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "label",
                                attrs: { for: "password" }
                              },
                              [_vm._v(_vm._s(_vm.$t("INPUT.PASS")))]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "InputField",
                          {
                            attrs: {
                              validation: ["required"],
                              "validation-func": _vm.isPasswordEqual,
                              meta: _vm.meta
                            }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.confirm_password,
                                  expression: "form.confirm_password"
                                }
                              ],
                              attrs: {
                                id: "confirm_password",
                                type: "password",
                                autocomplete: "off",
                                name: "confirm_password",
                                placeholder: " ",
                                required: "required"
                              },
                              domProps: { value: _vm.form.confirm_password },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "confirm_password",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "label",
                                attrs: { for: "confirm_password" }
                              },
                              [_vm._v(_vm._s(_vm.$t("INPUT.CONF_PASS")))]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "section",
                  { staticClass: "notes" },
                  [
                    _c("transition", { attrs: { name: "fade" } }, [
                      _vm.isYahooEmail
                        ? _c("div", {
                            staticClass: "YahooUsers",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("SIGN_UP.P_0"))
                            }
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("label", { staticClass: "choice checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.check,
                              expression: "form.check"
                            }
                          ],
                          attrs: { id: "", value: "", type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.form.check)
                              ? _vm._i(_vm.form.check, "") > -1
                              : _vm.form.check
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.form.check,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.form,
                                      "check",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.form,
                                      "check",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.form, "check", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.$t("SIGN_UP.P_2")) +
                                "\n                                    "
                            ),
                            _c(
                              "router-link",
                              {
                                staticClass: "text__bold color__secondary",
                                attrs: {
                                  to: { name: "terms-of-use" },
                                  target: "_blank"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(_vm.$t("LINK.TERM-2")) +
                                    "\n                                    "
                                )
                              ]
                            ),
                            _vm._v(
                              "\n                                    and \n                                    "
                            ),
                            _c(
                              "router-link",
                              {
                                staticClass: "text__bold color__secondary",
                                attrs: {
                                  to: { name: "privacy-policy" },
                                  target: "_blank"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(_vm.$t("LINK.PRIVACY")) +
                                    "\n                                    "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("section", { staticClass: "text__center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn full__width btn__round",
                      attrs: { type: "submit", disabled: _vm.disabled },
                      on: { click: _vm.submit }
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.message || _vm.$t("BUTTON.JOIN")) +
                          "\n                        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-4" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("SIGN_UP.P_3")) +
                        " \n                            "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "text__bold color__main",
                        on: { click: _vm.showLogin }
                      },
                      [_vm._v(_vm._s(_vm.$t("BUTTON.LOGIN")))]
                    )
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal__footer text__center" }, [
            _c("div", {
              staticClass: "BraveUsers fs__12",
              domProps: { innerHTML: _vm._s(_vm.$t("SIGN_UP.P_1")) }
            })
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }